export const REDUX_STORAGE_KEY = 'COZERO_APP_SETTINGS'
